// extracted by mini-css-extract-plugin
module.exports = {"module":"AddressNameAndType_module__h5jnp","name":"AddressNameAndType_name__9-B-Y","type":"AddressNameAndType_type__urWU8","showType":"AddressNameAndType_showType__2Wusu"};